import { sql } from 'drizzle-orm'
import { pgEnum, pgTable, text, uniqueIndex } from 'drizzle-orm/pg-core'
import {
  getBaseFields,
  getBaseIndexes,
  getTimestampWithTimezone,
  typedJsonb,
} from '../common/utils'

// Role enum
export const roleEnum = pgEnum('role', ['user', 'officer', 'admin', 'employee'])

// User status enum - for account access control only
export const userStatusEnum = pgEnum('user_status', [
  'active', // Can login and use the system
  'inactive', // Account disabled/blocked
])

// UI Language enum
export const uiLanguageEnum = pgEnum('ui_language', ['en', 'fi', 'es'])

// Users table
export const users = pgTable(
  'users',
  {
    ...getBaseFields(),
    email: text(), // Required for login. Phone-only users are lead/contact records (cannot log in).
    firstName: text().notNull().default(''),
    lastName: text().notNull().default(''),
    phoneNumber: text(),
    googleId: text(), // Google OAuth user ID
    roles: roleEnum('roles').array().notNull().default(['user']),
    status: userStatusEnum().notNull().default('active'),
    emailVerifiedAt: getTimestampWithTimezone(),
    marketingConsentAt: getTimestampWithTimezone(),
    uiLanguage: uiLanguageEnum().notNull().default('fi'),
    data: typedJsonb('data'), // Stores acquisition info including UTM params
  },
  (table) => ({
    ...getBaseIndexes('users', table),
    emailUniqueIdx: uniqueIndex('users_email_unique_idx').on(
      sql`lower(${table.email})`,
    ),
    googleIdUniqueIdx: uniqueIndex('users_google_id_unique_idx').on(
      table.googleId,
    ),
  }),
)
